import {
  Accordion,
  ActionIcon,
  Box,
  Grid,
  Group,
  NumberInput,
  Paper,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import {
  IconCheck,
  IconEdit,
  IconHelpCircleFilled,
  IconRepeat,
} from "@tabler/icons-react";

// --- SOUS-COMPOSANT POUR LES CARTES ---
const ProgramCard = ({
  icon,
  label,
  valueDisplay,
  helpText,
  rightBottom,
  bg,
  filled,
  editorComponent, // Remplacement de popoverContent par editorComponent
  isEditing,
  setIsEditing,
  hideEditIcon,
}) => {
  return (
    <Paper
      radius={"xl"}
      p="sm"
      pl="md"
      pr="xl"
      withBorder={!filled && !bg}
      bg={filled ? "var(--mantine-color-primary-filled)" : bg || "white"}
      c={filled ? "white" : "dark"}
      style={{
        border: bg ? `1px solid var(--mantine-color-primary-2)` : undefined,
        height: "100%",
      }}
      component={Group}
      align="center"
      pos={"relative"}
    >
      <Group wrap="nowrap" align="center" gap="md">
        <ThemeIcon
          size={48}
          radius="xl"
          variant={filled ? "white" : "filled"}
          color="primary"
        >
          {icon}
        </ThemeIcon>

        <Box style={{ flex: 1 }}>
          <Group justify="space-between" wrap="nowrap" align="start">
            <Text fw={600} c={filled ? "white" : "black"}>
              {label}
            </Text>
            {helpText && (
              <Tooltip label={helpText} multiline w={300} withArrow>
                <ThemeIcon
                  pos={"absolute"}
                  top={16}
                  right={16}
                  opacity={0.6}
                  size={"md"}
                >
                  <IconHelpCircleFilled size={24} />
                </ThemeIcon>
              </Tooltip>
            )}
          </Group>

          <Group justify="space-between" mt={4} wrap="nowrap" align="center">
            {isEditing ? (
              // --- MODE ÉDITION ---
              <Group gap="xs" wrap="nowrap" style={{ flex: 1 }}>
                <Box style={{ flex: 1 }}>{editorComponent}</Box>
                <ActionIcon
                  size="md"
                  variant="light"
                  color="teal"
                  onClick={() => setIsEditing(false)}
                >
                  <IconCheck size={18} />
                </ActionIcon>
              </Group>
            ) : (
              // --- MODE AFFICHAGE ---
              <>
                <Group gap="xs">
                  <Text fw={400} size="md">
                    {valueDisplay}
                  </Text>

                  {!hideEditIcon && (
                    <ActionIcon
                      size="sm"
                      variant="subtle"
                      color={filled ? "white" : "gray"}
                      onClick={() => setIsEditing(true)}
                    >
                      <IconEdit size={16} />
                    </ActionIcon>
                  )}
                </Group>

                {rightBottom && (
                  <Text size="xs" fw={500} c={filled ? "white" : "dark"}>
                    {rightBottom}
                  </Text>
                )}
              </>
            )}
          </Group>
        </Box>
      </Group>
    </Paper>
  );
};

export default ProgramCard;